import { javascriptWebWorker } from '@/app/web-workers/javascriptWebWorker/javascriptWebWorker';
import { multiplayer } from '@/app/web-workers/multiplayerWebWorker/multiplayer';
import { pythonWebWorker } from '@/app/web-workers/pythonWebWorker/pythonWebWorker';
import { quadraticCore } from '@/app/web-workers/quadraticCore/quadraticCore';
import { renderWebWorker } from '@/app/web-workers/renderWebWorker/renderWebWorker';

// this configures the Monaco editor to use web workers
import './monacoInit';

export interface LanguageWorkerOptions {
  python?: boolean;
  javascript?: boolean;
}

/**
 * Initialize core workers: render, multiplayer, quadraticCore.
 * These are required for the app to function.
 */
export const initCoreWorkers = () => {
  renderWebWorker.initWorker();
  multiplayer.initWorker();
  quadraticCore.initWorker();
};

/**
 * Initialize language workers: python, javascript.
 * These can be loaded on-demand or preloaded.
 */
export const initLanguageWorkers = (options: LanguageWorkerOptions = {}) => {
  const { python = true, javascript = true } = options;

  if (python) {
    pythonWebWorker.initWorker();
  }
  if (javascript) {
    javascriptWebWorker.initWorker();
  }
};

export interface WorkerInitOptions {
  preloadPython?: boolean;
  preloadJavascript?: boolean;
}

/**
 * Initialize all workers (core + language).
 * Convenience function that calls initCoreWorkers() and initLanguageWorkers().
 */
export const initWorkers = (options: WorkerInitOptions = {}) => {
  const { preloadPython = true, preloadJavascript = true } = options;

  initCoreWorkers();
  initLanguageWorkers({ python: preloadPython, javascript: preloadJavascript });
};
